import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class TrocasDevolucoesService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(codPessoa) {
    const response = await apinode.get(`/trocas-devolucoes/${this.idconta}`, {
      params: {
        codPessoa,
      },
    })

    return response.data
  }

  async getOne({ id_produto, id_pedido }) {
    const url = unifyParams(`/trocas-devolucoes/get/${this.idconta}`, [
      {
        key: 'id_produto',
        value: id_produto,
      },
      {
        key: 'id_pedido',
        value: id_pedido,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async create({
    id_cliente,
    id_pedido,
    id_funcionario,
    items,
    willAddBalance,
  }) {
    const response = await apinode.post(`/trocas-devolucoes/${this.idconta}`, {
      id_cliente,
      id_pedido,
      id_funcionario,
      items,
      willAddBalance,
    })

    return response.data
  }
}

export default new TrocasDevolucoesService()
